/**
 * /frontend/src/features/analytics/hooks/useAbandonmentAnalytics.js
 */

import { useCallback, useMemo } from 'react';
import { getAbandonmentBySection, getAbandonmentSummary, getAbandonmentTrend } from '../api/abandonmentAnalyticsApi';
import useAnalyticsResource from './useAnalyticsResource';

/**
 * Loads abandonment analytics data.
 * @param {Object} params
 * @returns {{data:any,isLoading:boolean,isError:boolean,error:any,refetch:Function}}
 */
const useAbandonmentAnalytics = (params = {}) => {
  const { request, storeToken, storeUuid, startDate, endDate, granularity, refreshSignal } = params;
  const enabled = Boolean(request && storeUuid);

  const fetcher = useCallback(async () => {
    const [summary, bySection, trend] = await Promise.all([
      getAbandonmentSummary(request, storeToken, storeUuid, startDate, endDate),
      getAbandonmentBySection(request, storeToken, storeUuid, startDate, endDate),
      getAbandonmentTrend(request, storeToken, storeUuid, startDate, endDate, granularity),
    ]);
    return { summary, bySection, trend };
  }, [endDate, granularity, request, startDate, storeToken, storeUuid]);

  const resource = useAnalyticsResource(enabled, fetcher, 'useAbandonmentAnalytics', refreshSignal);
  return useMemo(() => resource, [resource]);
};

export default useAbandonmentAnalytics;
